<template>
  <div class="fillin">
    <section class="head-wrapper">
      <header class="head">
        <a class="logo-wrapper" href="/">
          <img src="./logo.jpg" alt="logo" width="180" height="40">
        </a>
        <p class="text-wrapper">已有账号？
          <router-link class="gotoLog" to="/log">返回登录></router-link>
        </p>
      </header>
    </section>
    <div class="content">
      <section class="left-part">
        <h2 class="title">完善信息</h2>
        <p class="sub-title">Fill in information</p>
        <div class="img-wrapper">
          <img class="img" :src="imgurl" alt="cover" width="88" height="88">
          <vue-core-image-upload
            class="upload-button"
            crop="local"
            text=" "
            :cropBtn="{ok:'确定','cancel':'取消'}"
            cropRatio="1:1"
            @imageuploaded="imageuploaded"
            :max-file-size="5242880"
            :url="imgUpUrl">
          </vue-core-image-upload>
        </div>
        <p class="upimg-text">上传头像</p>
        <p class="hint-para">注: 为了更好的评判您的具体教学情况，请完善以下信息</p>
      </section>
      <section class="right-part">
        <div class="row">
          <span class="left">真实姓名:</span>
          <input type="text"
                 class="input-box" v-model="realname"
                 placeholder="请输入您的真实姓名"
                 maxlength="18">
        </div>
        <div class="row">
          <span class="left">性别:</span>
          <span class="sex-item" :class="{'selected':sexIndex==1}" @click="sexIndex=1">
            男
          </span>
          <span class="sex-item" :class="{'selected':sexIndex==2}" @click="sexIndex=2">
            女
          </span>
        </div>
        <div class="row">
          <span class="left">地区:</span>
          <el-cascader
            class="change-cascader"
            size="large"
            :options="areaOptions"
            v-model="selectedArea">
          </el-cascader>
        </div>
        <div class="row">
          <span class="left">执教起始:</span>
          <el-date-picker
            v-model="startDateValue"
            type="date"
            :editable="isFalse"
            :clearable='false'
            placeholder="选择日期"></el-date-picker>
        </div>
        <div class="row">
          <span class="left">教授课程:</span>
          <input type="text"
                 class="input-box" v-model="subject"
                 placeholder="如小学语文、初中数学、高中英语等"
                 maxlength="18">
        </div>
        <div class="row">
          <span class="left">微信账号:</span>
          <input type="text"
                 class="input-box"
                 v-model="wx"
                 placeholder="请填写微信号，方便为您安排生源">
        </div>
        <div class="row">
          <span class="left">学历:</span>
          <select name="type"
                  class="input-select"
                  :class="{'not-select':education===''}"
                  v-model="education">
            <option class="option" value='' disabled selected style='display:none;color:red'>大专、本科、硕士、博士等</option>
            <option class="option" value="大专">大专</option>
            <option class="option" value="本科">本科</option>
            <option class="option" value="硕士">硕士</option>
            <option class="option" value="博士">博士</option>
          </select>
        </div>
        <div class="row">
          <span class="left">毕业院校:</span>
          <input type="text"
                 class="input-box"
                 v-model="graduateSchool"
                 placeholder="如XX大学等">
        </div>
        <div class="row" v-if="education=='硕士'||education=='博士'">
          <span class="left">本科院校:</span>
          <input type="text"
                 class="input-box"
                 v-model="undergraduateschool"
                 placeholder="请填写本科毕业院校">
        </div>
        <div class="info-row">
          <span class="left">老师介绍:</span>
          <div class="right">
            <template v-for="(item,index) in introduceList">
              <div class="text-wrapper" v-if="item.isImage===false">
              <textarea class="text"
                        v-model='item.text'
                        name="text"
                        cols="20"
                        rows="5"></textarea>
                <img class="delete-img" @click="del(1,index)" src="./delete.png" alt="delete-button" width="16"
                     height="16">
              </div>
              <div class="img-wrapper" v-if="item.isImage===true">
                <div class="img-left">
                  <img class='showimg' :src="introduceImgUrl(item)" alt="img" width="80" height="50"><input
                  class="input" type="file" accept="image/*" @change="upImg(1,index,$event)"/>
                  <img class="delete-img" @click="del(1,index)" src="./delete.png" alt="delete-button" width="16"
                       height="16">
                </div>

              </div>
            </template>
            <button class="add" @click="addText(1)">添加文字</button>
            <button class="add no-margin" @click="addImage(1)">添加图片</button>
            <span class="example" style="height: 40px" @mouseenter="showExampleArea = true" @mouseleave="showExampleArea = false">示例</span>
            <transition name="fade">
              <div class="example-area" v-show="showExampleArea"
                   @mouseenter="showExampleArea = true" @mouseleave="showExampleArea = false">
                <p>介绍：本人从事教育教学工作XX年，有多年的带班经验和教研工作经验。我多次获得市级教学能手、模范教师和模范班主任荣誉称号，在学校中担任学科负责人、教研组组长等职务。<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我擅长英语阅读理解、写作及语法方面的知识点教学，所带学生多次在英语演讲比赛和知识竞赛中获得奖项，历届学生成绩都非常优秀。针对考试成绩不理想的同学，经过我一对一针对性的补习短期内成绩提分20＋。<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在课堂上，我会营造风趣幽默氛围，轻松活泼，旨在寓教于乐，深得学生和家长的喜爱。
                </p>
                <div style="display: flex; justify-content: space-evenly; align-items: center">
                  <img src="./example01.png" alt="" width="150">
                  <img src="./example02.png" alt="" width="200">
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <span class="left" style="width: 70px;margin-right:20px;">证书<span style="color:#ff6700">(选填):</span></span>
          <section class="right">
            <template v-for="(item,index) in upcertificateList">
              <section class="certificate-item" v-if="!isEmpty(item.list)">
                <p class="certificate-item-title">{{decodeURIComponent(item.name)}}:</p>
                <section class="certificate-img-wrapper">
                  <template v-for="(item2,index2) in item.list">
                    <div class="certificate-img-item">
                      <img :src="imgprefix+item2" alt="图片" width="80" height="50">
                    </div>
                  </template>
                </section>
              </section>
            </template>
            <button class="up-img" @click="QueryTeacherCerLabel">上传证书照片</button>
          </section>
        </div>
        <div class="row" style="margin-top:20px;">
          <span class="left" style="width: 70px;margin-right:20px;">标签<span style="color:#ff6700">(选填):</span></span>
          <section class="right">
            <template v-for="item in selectLabelList">
              <template v-for="item2 in item.list" v-if="item2.show==true">
                <span class="label-item">{{decodeURIComponent(item2.name)}}</span>
              </template>
            </template>
            <button class="select-label" @click="QueryTeacherLabel">选择标签</button>
          </section>
        </div>
        <button class="next-btn" @click="UpdateRoomTeacherOwnerInfo">完成注册</button>
      </section>
    </div>
    <div class="labelpop-mask" v-if="labelShow">
      <div class="labelpop-wrapper">
        <h2 class="title">标签 <img @click="labelShow=false;" class="close" src="./close.png" alt="关闭" width="20"
                                  height="20"></h2>
        <template v-for="(item,index) in labelList">
          <p class="label-title">{{decodeURIComponent(item.name)}}</p>
          <section class="label-wrapper">
            <template v-for="item2 in item.list">
              <span @click="selectLabel(item2)" class="label-item"
                    :class="{'selected':item2.show==true}">{{decodeURIComponent(item2.name)}}</span>
            </template>
          </section>
        </template>
        <button class="label-save" @click="saveSelectLabelList">保存</button>
      </div>
    </div>
    <div class="labelpop-mask" v-if="certificateShow">
      <div class="labelpop-wrapper" style="width:340px;height:450px;">
        <h2 class="title">{{upTitleText}}<img @click="certificateShow=false;" class="close" src="./close.png" alt="关闭" width="20"
                                  height="20"></h2>
        <section class="type-wrapper">
          <template v-for="(item,index) in certificateTypeList">
            <p class="certificate-row">
              <span class="left-text">{{decodeURIComponent(item.name)}}:</span>
              <button class="right-btn">上传
                <input class="input-certificate"
                       type="file" accept="image/*" @change="upCertificateImg(item.id,$event)"/></button>
            </p>
          </template>
        </section>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {clone} from 'common/js/clone';
  //https://www.npmjs.com/package/element-china-area-data
  import {
    provinceAndCityData,
    regionData,
    provinceAndCityDataPlus,
    regionDataPlus,
    CodeToText,
    TextToCode
  } from 'element-china-area-data'
  import {saveLocal, loadLocal, saveSession, loadSession} from 'common/js/store.js';
  import VueCoreImageUpload from 'vue-core-image-upload';
  export default{
    data(){
      return {
        isFalse:false,
        id: (() => loadLocal('id', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        imgUpUrl: '',              //该url是组件‘vue-core-image-upload’上传的url地址（带sessionid）
        imgurl: require('./avatar.png'),
        upurl: '',
        realname: '',
        sexIndex: 1,
        startDateValue: '',
        subject: '',
        wx: '',
        areaOptions: provinceAndCityData,
        selectedArea: [],
        education: '',         //学历
        graduateSchool: '',    //毕业院校
        undergraduateschool:'',
        introduceList: [],
        index: 0,        //根据上传图片确定index，从而对相应的list[this.index]赋值
        showExampleArea: false, // 显示模板
        //-------------证书上传--------------//
        certificateShow: false,
        certificateTypeList: [],      //模态框用来显示的证书列表
        upcertificateList: [],         //上传使用的证书列表，相当于在certificateTypeList的每个子项加入了list
        nowCertificateId: null,
        upTitleText:'证书上传',
        //-------------标签列表--------------//
        labelList: [],
        selectLabelList: [],
        labelShow: false,
      }
    },
    methods: {
      //VueCoreImageUpload上传后调用的方法
      imageuploaded(response) {
        if (response.code === 200) {
          this.imgurl = response.imgprefix + response.image;
          this.upurl = response.image;
        }
      },
      //删除添加文字、添加图片的某一项
      del: function (type, index) {
        //type为1是个人介绍，type为2是教学经验，type为3是相关证书
        if (type === 1) {
          this.introduceList.splice(index, 1);
        }
//        else if (type === 2) {
//          this.experienceList.splice(index, 1);
//        } else if (type === 3) {
//          this.certifyList.splice(index, 1);
//        }
        this.$forceUpdate()  // 迫使 Vue 实例重新渲染。
      },
      //增加文字、图片的相关方法
      addText(type){
        let oText = {
          "isImage": false,
          "text": '',
        };
        //type为1是个人介绍，type为2是教学经验，type为3是相关证书
        if (type === 1) {
          this.introduceList.push(oText);
        }
//        else if (type === 2) {
//          this.experienceList.push(oText);
//        } else if (type === 3) {
//          this.certifyList.push(oText);
//        }
        this.$forceUpdate();
      },
      addImage(type){
        let oText = {
          "isImage": true,
          "image": './addImage.png',
          "width": 0,
          "height": 0,
        };
        //type为1是个人介绍，type为2是教学经验，type为3是相关证书
        if (type === 1) {
          this.introduceList.push(oText);
        }
//        else if (type === 2) {
//          this.experienceList.push(oText);
//        } else if (type === 3) {
//          this.certifyList.push(oText);
//        }
        this.$forceUpdate();
      },
      introduceImgUrl(item){
        if (item.image === './addImage.png') {
          return require('./addImage.png');
        } else {
          return this.imgprefix + item.image;
        }
      },
      upImg: function (type, index, e) {
        this.index = index;
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let image = input.previousSibling;
          image.src = e.target.result;
        };
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        if (type === 1) {
          xhr.addEventListener('load', this.uploadComplete, false);
        }
//        else if (type === 2) {
//          xhr.addEventListener('load', this.uploadComplete2, false);
//        } else if (type === 3) {
//          xhr.addEventListener('load', this.uploadComplete3, false);
//        }
        //send the file
        xhr.send(file);
      },
      uploadComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.$set(this.introduceList[this.index], 'image', jsonobj.image);
        this.$set(this.introduceList[this.index], 'width', jsonobj.imagewidth);
        this.$set(this.introduceList[this.index], 'height', jsonobj.imageheight);
        this.$forceUpdate();
      },
      UpdateRoomTeacherOwnerInfo(){
        if (this.upurl === '') {
          this.$message({
            message: '请上传头像',
            type: 'warning'
          });
          return;
        }
        if (this.realname === '') {
          this.$message({
            message: '请输入真实姓名',
            type: 'warning'
          });
          return;
        }
        if (this.isEmpty(this.selectedArea)) {
          this.$message({
            message: '请选择地区',
            type: 'warning'
          });
          return;
        }
        if (this.startDateValue==='') {
          this.$message({
            message: '请选择执教起始日期',
            type: 'warning'
          });
          return;
        }
        if (this.subject === '') {
          this.$message({
            message: '请输入教授课程',
            type: 'warning'
          });
          return;
        }
        if (this.wx === '') {
          this.$message({
            message: '请输入微信账号',
            type: 'warning'
          });
          return;
        }
        if (this.education === '') {
          this.$message({
            message: '请输入学历',
            type: 'warning'
          });
          return;
        }
        if (this.graduateSchool === '') {
          this.$message({
            message: '请填写毕业院校',
            type: 'warning'
          });
          return;
        }
        if(this.education=='硕士'||this.education=='博士'){
          if(this.undergraduateschool===''){
            this.$message({
              message: '请填写本科毕业院校',
              type: 'warning'
            });
            return;
          }
        }
        if (this.computeUpIntroduceList(this.introduceList) === '') {
          this.$message({
            message: '请填写老师介绍',
            type: 'warning'
          });
          return;
        }
        let totalTextLength=0;
        for(let i=0;i<this.introduceList.length;i++){
          if(this.introduceList[i].isImage==false){
            totalTextLength+=this.introduceList[i].text.length;
          }
        }
        if(totalTextLength<60){
          this.$message({
            message: '添加的文字介绍总和需大于60字',
            type: 'warning'
          });
          return;
        }
        let url = '/indexapp.php?c=Teacher&a=UpdateRoomTeacherOwnerInfo';
        let params = new URLSearchParams();
        params.append('id', this.id);
        params.append('rid', 0);
        //头像
        params.append('faceimg', this.upurl);
        //真实姓名
        params.append('realname', this.realname);
        if(this.education=='硕士'||this.education=='博士'){
          params.append('undergraduateschool', this.undergraduateschool);
        }else{
          params.append('undergraduateschool', '');
        }
        //性别
        if(this.sexIndex==1){
          params.append('sex', '男');
        }else{
          params.append('sex', '女');
        }
        //显示名称（上一页传入的）
        let teacherInfo = loadLocal('userinfo', false);
        let teachername = decodeURIComponent(teacherInfo.uname);
        params.append('teachername', teachername);
        //地区
        let area='';
        for(let i=0;i<this.selectedArea.length;i++){
          area+=CodeToText[this.selectedArea[i]]
        }
        params.append('area', area);
        //执教起始时间
        params.append('teacherage', this.getAgeTime(this.startDateValue));
        //教授课程
        params.append('lessonlist', this.subject);
        //微信账号
        params.append('wx', this.wx);
        //学历
        params.append('education', this.education);
        //毕业学校
        params.append('graduateschool', this.graduateSchool);
        //老师介绍
        let introduce = this.computeUpIntroduceList(this.introduceList);
        params.append('introduce', introduce);
        //证书
        params.append('certificate', this.upCertificate(this.upcertificateList));
        //标签
        params.append('label', this.upLabel(this.selectLabelList));
        this.$http({
          url: url,
          method: 'post',
          data: params,
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            window.location.replace('/');
          }
        }).catch((err) => {

        })
      },
      getAgeTime(date){
        let month = "0" + (date.getMonth() + 1);
        let day = "0" + date.getDate();

        return  date.getFullYear() + '-' + month.substring(month.length - 2) + '-' + day.substring(day.length - 2);
      },
      upCertificate(list){
        //当前证书列表是空数组（[]），即用户没有点击证书
        if(this.isEmpty(list)){
          return '';
        }
        let result='';
        list.forEach(function (item) {
          if(item.list.length>0){
            if(result===''){
              result=[];
            }
            result.push(item);
          }
        })
        return JSON.stringify(result);
      },
      upLabel(labelList){
        //当前选择标签列表是空数组（[]），即用户没有点击获取标签
        if(this.isEmpty(labelList)){
          return '';
        }
        let result='';
        //需要进行两次循环
        labelList.forEach(function(item){
          item.list.forEach(function (innerItem) {
            if(innerItem.show===true){
              if(result===''){
                result=[];
              }
              result.push(innerItem.name);
            }
          })
        })
        var reg = new RegExp( ',' , "g" )
        return result.toString().replace(reg,';');
      },
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      //根据当前introduceList的值，返回相应的符合上传需求的数据
      computeUpIntroduceList(list){
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].isImage === true) {
              if (list[i].width === 0) {
                continue;
              }
            } else {
              if (list[i].text === '') {
                continue;
              }
            }
            result.push(list[i]);
          }
          if (this.isEmpty(result)) {
            return '';
          }
          result = JSON.stringify(result);
          result = encodeURIComponent(result);
          return result;
        }
      },
      //获取证书
      QueryTeacherCerLabel(){
        this.upTitleText='证书上传';
        if (!this.isEmpty(this.certificateTypeList)) {
          this.certificateShow = true;
          return;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Teacher',
            a: 'QueryTeacherCerLabel',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code == 200) {
            this.certificateTypeList = response.list;
            let tempList = clone(response.list);
            tempList.forEach(function (item) {
              item.list = [];
            })
            this.upcertificateList = tempList;
            this.certificateShow = true;
          }
        }).catch((err) => {
          console.log('err: ', err)
        });
      },
      upCertificateImg(id, e){
        this.nowCertificateId = id;
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        xhr.addEventListener('load', this.uploadCertificateComplete, false);
        //send the file
        xhr.send(file);
        this.certificateShow = false;
      },
      uploadCertificateComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.upcertificateList.forEach((item) => {
          if (item.id === this.nowCertificateId) {
            item.list.push(jsonobj.image)
          }
        });
        this.$message({
          message: '上传成功',
          type: 'success',
        });
        this.$forceUpdate();
      },
      deleteCertificateImg(index,index2){
        this.upcertificateList[index].list.splice(index2,1);
      },
      //获取标签
      QueryTeacherLabel(){
        this.upTitleText='标签';
        if (!this.isEmpty(this.labelList)) {
          this.labelList = clone(this.selectLabelList);
          this.labelShow = true;
          return;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Teacher',
            a: 'QueryTeacherLabel',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code == 200) {
            let tempList = response.list;
            tempList.forEach(function (item) {
              item.list.forEach(function (inneritem) {
                inneritem.show = false;
              })
            })
            this.labelList = tempList;
            this.selectLabelList = clone(tempList);
            this.labelShow = true;
          }
        }).catch((err) => {
          console.log('err: ', err)
        });
      },
      selectLabel(item){
        item.show = !item.show;
        this.$forceUpdate();
      },
      saveSelectLabelList(){
        this.selectLabelList = clone(this.labelList);
        this.labelShow = false;
      },
    },
    created(){
      this.imgUpUrl = `${this.GLOBAL.uploadUrl}indexapp.php?c=Upload&a=UploadFileVue&id=` + this.id;
    },
    components: {
      VueCoreImageUpload,
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .change-cascader.el-cascader
    width: 360px;
    .el-input__inner {
      border: 1px solid #ccc;
      border-radius: 0;
      padding-right: 40px;
      background: #fff url('./input-down.png') no-repeat right 20px center / 20px 20px
    }
    .el-input__suffix
      display: none

  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 360px;
    .el-input__inner
      color: #333
      border: 1px solid #ccc;
      border-radius: 0;
      background: #fff url('./input-down.png') no-repeat right 20px center / 20px 20px
      &::-webkit-input-placeholder
        color: #ccc
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .fillin
    padding-bottom: 30px
    min-height: 100%
    background: #ffffff url('./background.png') no-repeat center / cover
    .fade-enter-active, .fade-leave-active {
      transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
    .head-wrapper
      width: 100%
      background: #fff
      .head
        width: 1226px
        height: 80px
        margin: 0 auto
        background: #fff
        font-size: 0
        .logo-wrapper
          float: left;
          height: 43px;
          width: 192px;
          padding-top: 18px;
        .text-wrapper
          float: right
          height: 80px
          line-height: 80px
          font-size: 14px
          color: #333
          text-align: center
          .gotoLog
            color: #ff6700
    .content
      margin: 40px auto 0
      padding-bottom: 20px
      font-size: 0
      width: 990px
      background: #ffffff
      &::after
        content: ' '
        display: block
        height: 0;
        visibility: hidden
        clear: both
      .left-part
        float: left
        width: 435px
        .title
          padding-top: 40px;
          height: 42px
          line-height: 42px
          text-align: center
          font-size: 30px
          color: #333
        .sub-title
          height: 20px
          line-height: 20px
          font-size: 14px
          color: #333333
          text-align: center
        .img-wrapper
          width: 88px
          height: 88px
          margin: 60px auto 30px
          position: relative
          .upload-button
            position: absolute
            top: 0
            right: 0
            bottom: 0
            left: 0
        .upimg-text
          height: 22px
          line-height: 22px
          font-size: 14px
          color: #ff6700
          width: 64px
          text-align center
          margin: 0 auto
          position: relative
          &.error::after
            content: ' '
            display: inline-block
            position: absolute
            width: 18px
            height: 18px
            background: url('./hint-error.png') no-repeat center / 18px 18px
            top: 2px
            right: -26px
        .hint-para
          margin: 30px auto 0
          line-height: 20px
          font-size: 14px
          color: #cccccc
          width: 196px
          text-align: center
      .right-part
        float: left
        width: 555px
        padding-top: 10px
        .row
          clear: both
          height: 40px
          margin-top: 30px
          .left
            float: left
            margin-right: 30px
            width: 60px
            height: 40px
            line-height: 40px
            color: #333
            font-size: 14px
          .input-box
            float: left
            padding-left: 20px
            width: 360px
            height: 40px
            line-height: 40px
            font-size: 14px
            color: #333
            border: 1px solid #ccc
            box-sizing: border-box
            position: relative
            &::-webkit-input-placeholder
              color: #ccc
          .input-select
            float: left
            width: 360px
            height: 40px
            line-height: 40px
            font-size: 14px
            border: 1px solid #ccc
            position: relative
            -webkit-appearance: none
            -moz-appearance: none
            appearance: none
            background: #fff url('./input-down.png') no-repeat right 20px center / 20px 20px
            padding: 0 40px 0 20px
            box-sizing: border-box
            &.not-select
              color: #ccc
          .option
            -moz-appearance: none; /* Firefox */
            -webkit-appearance: none; /* Safari 和 Chrome */
            appearance: none;
            color: #333
            text-align: center
          .sex-item
            float: left
            margin-right: 70px
            padding-left: 36px
            width: 50px
            height: 40px
            line-height: 40px
            font-size: 14px
            color: #333333
            box-sizing: border-box
            cursor: pointer
            background: url('./before-select.png') no-repeat left center / 16px 16px
            &.selected
              background: url('./selected.png') no-repeat left center / 16px 16px
          .right
            float: left
            width: 360px
            .select-label, .up-img
              clear: both
              margin-bottom: 40px
              float: left
              width: 96px
              height: 40px
              line-height: 40px
              font-size: 14px
              color: #ffffff
              text-align: center
              background: #ff6700
            .up-img
              margin-bottom: 20px
              width: 150px
              text-indent: 40px
              background: #ff6700 url('./up-img.png') no-repeat left 20px center / 20px 20px
            .label-item
              margin: 0 10px 20px 0
              font-size: 14px
              color: #ffffff
              float: left
              padding-left: 18px
              width: 90px
              height: 36px
              line-height: 36px
              text-align: center
              box-sizing: border-box
              background: url('./label-selected.png') no-repeat center / 90px 36px
              position: relative

            .certificate-item
              float: left
              width: 100%
              .certificate-item-title
                width: 100%
                font-size: 14px
                color: #333333
                height: 40px;
                line-height: 40px;
              .certificate-img-wrapper
                float: left
                font-size: 0
                .certificate-img-item
                  float: left
                  width: 80px
                  height: 50px
                  margin: 0 15px 10px 0
                  position: relative
                  font-size:0
                  .delete-img
                    position: absolute
                    top: -8px
                    right: -8px
                    cursor: pointer

        .info-row
          clear: both
          margin-top: 30px
          &::after
            content: ' '
            display: block
            height: 0;
            visibility: hidden
            clear: both
          .left
            float: left
            margin-right: 30px
            width: 60px
            height: 40px
            line-height: 40px
            color: #333
            font-size: 14px

          .right
            float: left
            width: 360px
            position: relative
            .example-area
              position: absolute
              bottom: 36px
              right: -26px
              padding: 20px
              border: 1px solid #ebeef5
              transition: all .3s
              box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
              background-color: #fff
              border-radius: 10px
              width: 500px

              p
                font-size: 14px
                color: #606266
                line-height: 21px
                text-align: justify
                margin-bottom: 10px
              img
                vertical-align: top

            .example
              color: #409eff
              cursor: pointer
              font-size: 14px
              position: absolute
              bottom: 0
              right: -35px
              line-height: 40px
            .text-wrapper
              clear: both
              float: left
              margin-bottom: 10px
              position: relative
              .text
                float: left
                padding: 10px 20px
                width: 360px
                height: 80px
                font-size: 14px
                color: #333
                box-sizing border-box
                border: 1px solid #ccc
                line-height: 20px
                resize: none
              .delete-img
                position: absolute
                right: -6px
                top: -6px
                cursor pointer
            .img-wrapper
              clear: both
              float: left
              width: 360px
              margin-bottom: 10px
              .img-left
                float: left
                width: 80px
                height: 50px
                position relative
                .input
                  position: absolute
                  left: 0
                  top: 0
                  width: 100%
                  height: 100%
                  cursor: pointer
                  opacity: 0
                .delete-img
                  position: absolute
                  right: -6px
                  top: -6px
                  cursor pointer
            .add
              clear: both
              margin-right: 10px
              height: 40px
              line-height: 40px
              width: 175px
              font-size: 14px
              color: #333
              border: 1px solid #ccc
              box-sizing border-box
              &.no-margin
                margin-right: 0

      .next-btn
        clear: both
        margin: 0 0 0 90px
        display: block
        width: 360px
        height: 50px
        line-height: 50px
        text-align: center
        font-size: 14px
        color: #ffffff
        background #ff6700

    .labelpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .labelpop-wrapper
        margin: auto
        width: 560px
        height: 450px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position: relative
        .title
          padding-left: 15px
          height: 50px
          line-height: 50px
          font-size: 14px
          color: #333333
          background: #f5f5f5
          .close
            float: right
            margin: 15px 15px 0 0
            cursor pointer
        .label-title
          clear: both
          margin: 20px 0 0 15px
          font-size: 14px
          color: #333333
        .label-wrapper
          margin: 10px 0 0 15px
          overflow: hidden
          .label-item
            float: left
            margin-right: 10px
            font-size: 14px
            color: #ffffff
            padding-left: 18px
            width: 90px
            height: 36px
            line-height: 36px
            text-align: center
            box-sizing: border-box
            background: url('./label-before-select.png') no-repeat center / 90px 36px
            cursor: pointer
            position: relative
            &.selected
              background: url('./label-selected.png') no-repeat center / 90px 36px
        .label-save
          position: absolute
          bottom: 15px
          left: 15px
          width: 114px
          height: 40px
          line-height: 40px
          text-align: center
          font-size: 14px
          color: #ffffff
          background: #ff6700
        .type-wrapper
          .certificate-row
            margin: 30px 35px 0
            height: 26px
            .left-text
              float: left
              line-height: 26px
              font-size: 14px
              color: #333
            .right-btn
              float: right
              width: 80px
              height: 26px
              line-height: 26px
              font-size: 14px
              color: #ffffff
              border-radius: 13px
              background: #ff6700
              position: relative
              .input-certificate
                position: absolute
                left: 0
                top: 0
                width: 100%
                height: 100%
                opacity: 0
                cursor: pointer
</style>



// WEBPACK FOOTER //
// src/page/register/Fillin.vue